
import { Database, CheckCircle, Plus, Wifi, WifiOff } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface CacheIndicatorProps {
  isUsingCache: boolean;
  newVideosCount?: number;
}

const CacheIndicator = ({ isUsingCache, newVideosCount = 0 }: CacheIndicatorProps) => {
  if (!isUsingCache) return null;

  return (
    <div className="flex items-center justify-center mb-4">
      <Badge variant="secondary" className="flex items-center gap-2 px-3 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
        <Wifi className="h-4 w-4" />
        <span className="text-sm">Données mises à jour - API YouTube actif</span>
        {newVideosCount > 0 && (
          <>
            <Plus className="h-3 w-3" />
            <span className="text-xs bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-2 py-0.5 rounded-full">
              +{newVideosCount} nouvelles
            </span>
          </>
        )}
        <CheckCircle className="h-4 w-4" />
      </Badge>
    </div>
  );
};

export default CacheIndicator;
